import { sortBy } from 'lodash';
import React from 'react';
import type { IServiceTypeWithOneService } from '@common/interfaces';
import type { UnavailableService } from '@common/interfaces/patientUnavailableServices';
import type { ServiceType } from '../../../../../../common/enums/serviceType';
import { serviceTypeButtonSortOrder } from '../../../../../../common/utils/serviceSortUtils';
import { ProcessStartWizardButtonRow } from '../../../../elements/ProcessStartWizard/ProcessStartWizardButtonRow';
import { NewProcessButtonRow } from './NewProcessButtonRow';

interface INewProcessTypeButtonRowProps {
    label: string;
    onClick: (serviceType: ServiceType) => Promise<void>;
    scrollToBottom?: () => void;
    selectedServiceType: ServiceType | undefined;
    serviceTypes: IServiceTypeWithOneService[];
    unavailableServices: UnavailableService[];
}

export function NewProcessTypeButtonRow(props: INewProcessTypeButtonRowProps): React.ReactElement {
    return (
        <ProcessStartWizardButtonRow label={props.label}>
            {sortBy(props.serviceTypes, (serviceType) => serviceTypeButtonSortOrder[serviceType.name]).map(
                (serviceType) => {
                    return (
                        <NewProcessButtonRow
                            automation={`processFlowType-${serviceType.name}`}
                            data={serviceType}
                            key={serviceType.name}
                            onClick={props.onClick}
                            previousSelection={props.selectedServiceType}
                            scrollToBottom={props.scrollToBottom}
                            translationKey="home.type_"
                            unavailableServices={props.unavailableServices}
                        />
                    );
                }
            )}
        </ProcessStartWizardButtonRow>
    );
}
